module.exports = __webpack_public_path__ + "static/admin-home-page.634a38c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin-home-page.png
// module id = 430
// module chunks = 35783957827783